import Service from '@/shared/classes/service'
import Company from '@/shared/modules/company/company.model'

export default class ToolCategoryService extends Service {
  static prefix: string = 'tool-categories'

  static deactivate(company: Company, toolCategoryUuid: string): Promise<any> {
    return this.put(`company/${ company.slug }/${ this.prefix }/${ toolCategoryUuid }/deactivate`, {})
  }
}